module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "container1"
  }, [_c('div', {
    staticClass: "ticker"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "news"
  }, [_c('marquee', {
    staticClass: "news-content",
    attrs: {
      "behavior": "scroll",
      "scrollamount": "3"
    }
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('p', {
      key: index
    }, [_c('span', {
      staticClass: "blink"
    }, [_vm._v("👉")]), _vm._v(" " + _vm._s(notification.name) + " ")])
  }), 0)], 1)]), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.user.type == 'member') ? _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body text-center"
  }, [_c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.loansummery
    }
  }, [_c('i', {
    staticClass: "fa fa-leanpub"
  }), _vm._v(" Loan Details\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.collections
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" Paid EMI\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.emis
    }
  }, [_c('i', {
    staticClass: "fa fa-inr"
  }), _vm._v(" Due EMI\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.emireceipt
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("EMI Receipt\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('center', [_c('clock', {
    attrs: {
      "border": "2px solid",
      "color": "white",
      "bg": "red",
      "size": "130px"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('membercollection')], 1)])]) : _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body text-center"
  }, [(_vm.canAccess('member-create')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.users
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Members\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-plan-create')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.plans
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Plan\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-create-loan')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.individualloans
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Loan\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-create-loan')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.grouploans
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt"
  }), _vm._v(" Group Loan\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-loan-plan-view-any')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.loansummery
    }
  }, [_c('i', {
    staticClass: "fa fa-leanpub"
  }), _vm._v(" Loan Details\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-emi-view')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.emis
    }
  }, [_c('i', {
    staticClass: "fa fa-inr"
  }), _vm._v(" Collect EMI\n              ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('sattlement-create')) ? _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.settlements
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Settlement\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('center', [_c('clock', {
    attrs: {
      "border": "2px solid",
      "color": "white",
      "bg": "red",
      "size": "128px"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.canAccess('menu-portfolio')) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('center', [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v(" Branch ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.loadData()
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('br'), _c('br')], 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('balancerecord', {
    attrs: {
      "message": _vm.dashboardRecord
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('totaloutstanding', {
    attrs: {
      "message": _vm.dashboardRecord
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('totalcollection', {
    attrs: {
      "message": _vm.dashboardRecord
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('interestbalance', {
    attrs: {
      "message": _vm.dashboardRecord
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "box info-box box-widget widget-user"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Today "), (_vm.dashboardRecord[7]) ? _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[7].collectionApprovedDaily))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Weekly "), (_vm.dashboardRecord[8]) ? _c('span', {
    staticClass: "pull-right badge bg-aqua"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[8].collectionApprovedWeekly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly "), (_vm.dashboardRecord[9]) ? _c('span', {
    staticClass: "pull-right badge bg-green"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[9].collectionApprovedMonthly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Total "), (_vm.dashboardRecord[10]) ? _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[10].collectionApprovedTotal))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-widget widget-user"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Today "), (_vm.dashboardRecord[12]) ? _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[12].collectionPendingDaily))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Weekly "), (_vm.dashboardRecord[13]) ? _c('span', {
    staticClass: "pull-right badge bg-aqua"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[13].collectionPendingWeekly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly "), (_vm.dashboardRecord[14]) ? _c('span', {
    staticClass: "pull-right badge bg-warning"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[14].collectionPendingMonthly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Total "), (_vm.dashboardRecord[15]) ? _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[15].collectionPendingTotal))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-widget widget-user"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Today "), (_vm.dashboardRecord[17]) ? _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[17].disbursmentApprovedDaily))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Weekly "), (_vm.dashboardRecord[18]) ? _c('span', {
    staticClass: "pull-right badge bg-aqua"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[18].disbursmentApprovedWeekly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly "), (_vm.dashboardRecord[19]) ? _c('span', {
    staticClass: "pull-right badge bg-green"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[19].disbursmentApprovedMonthly))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Total "), (_vm.dashboardRecord[20]) ? _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[20].disbursmentApprovedTotal))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-widget widget-user"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Today "), (_vm.dashboardRecord[22]) ? _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[22].disbursmentPendingDailyRows))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Weekly "), (_vm.dashboardRecord[23]) ? _c('span', {
    staticClass: "pull-right badge bg-aqua"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[23].disbursmentPendingWeeklyRows))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly "), (_vm.dashboardRecord[24]) ? _c('span', {
    staticClass: "pull-right badge bg-green"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[24].disbursmentPendingMonthlyRows))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Total "), (_vm.dashboardRecord[25]) ? _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_vm._v(_vm._s(_vm.dashboardRecord[25].disbursmentPendingTotalRows))]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('profitloss'), _vm._v(" "), _c('pendingrecords'), _vm._v(" "), _c('membercollection'), _vm._v(" "), (_vm.canAccess('disbursment-view-any')) ? _c('recentdisbursment') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('recentmember')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v(" 🔔 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header text-center"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Short Keys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header text-center"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Short Keys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-user-header box-green"
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Collection")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Approved In Amount")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("1234")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-user-header box-red"
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Collection")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Pending In Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-user-header box-green"
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Disbursement")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Approved In Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-user-header box-red"
  }, [_c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v("Disbursement")]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v("Pending Number Of Loans")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2f28210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/Dashboard.v1.vue
// module id = 872
// module chunks = 0